<template>
  <pnet-validation-observer>
    <div class="container">
      <div v-for="(rangeValue, index) in nestedRangeValues" v-bind:key="index">
        <div class="row">
          <div class="col">
            <label>
              <small>{{labels[0]}}{{ index + 1 }}</small>
            </label>
            <text-field v-model="rangeValue.from"></text-field>
          </div>
          <div class="col">
            <label v-if="labels[1]">
              <small>{{labels[1]}}{{ index + 1 }}</small>
            </label>
            <text-field v-model="rangeValue.to"></text-field>
          </div>
        </div>
        <div class="row">
          <range-values
            :labels="['minC','maxC','valR']"
            v-model="rangeValue.rangeValues"
          ></range-values>
        </div>
      </div>
      <div class="col-12 pt-3 pb-3">
        <div class="filtri mb-4">
          <div class="col-12 col-md-4 col-lg-12" align="left">
            <button class="btn btn-primary mt-4 p-1 pl-3 pr-3" v-on:click.prevent="inserisci">+</button>
            <button
              v-if="nestedRangeValues.length > 1"
              class="btn btn-primary mt-4 p-1 pl-3 pr-3"
              v-on:click.prevent="cancella"
            >-</button>
          </div>
        </div>
      </div>
    </div>
  </pnet-validation-observer>
</template>

<script lang="js">
import Vue from "vue";
import RangeValues from "@/components/RangeValues.vue";
import TextField from "@/components/TextField.vue";
export default Vue.extend({
  props: ["labels","value"],
  components: {
    RangeValues,
    TextField
  },
  data: function() {
    return {
      nestedRangeValues: [
        {
          order: 0,
          from: "",
          to: "",
          rangeValues: []
        },
      ]
    }},
  methods: {
    inserisci: function() {
      this.nestedRangeValues.push({
        order: this.nestedRangeValues.length,
      });
    },
    cancella: function() {
      this.nestedRangeValues.pop();
    },
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(){
        this.nestedRangeValues = this.value;
      }
    },
    nestedRangeValue: {
      deep: true,
      immediate: true,
      handler(){
        this.$emit('input', this.nestedRangeValues);

      }
    }
  },
  mounted() {
    this.rangeValues = this.value;
  }
});
</script>